import { Toast } from "primereact/toast";
import { useRef, useState } from "react";

import { Authorization } from "../../common/AuthorizationCpt";
import {
  onlyDigits,
  onlyDigitsNumbers,
} from "../../common/components/TemplateContainer/InputTemplates";
import { FILTERS, REQUEST_STATES } from "../../utils/constants";
import {
  DAM_EXTENSION_ONE_MAX_LENGTH,
  DAM_EXTENSION_TWO_MAX_LENGTH,
  DAM_MAX_LENGTH,
  DOCUMENT_DNI_MAX_LENGTH,
} from "../../utils/valueStaticConstants";
import Input from "../Input/Input";
import MultipleTagInput from "../MultipleTagInput/MultipleTagInput";
import { SearchBar } from "../Payment/FilterStyles";
import { ResetButton, SearchButton } from "../SearchButtons/SearchButtons";
import Select from "../Select/Select";
import {
  DamExtension,
  DamInput,
  DamSuffix,
} from "./BillingSearchBarAdminStyles";

export const INITIAL_FILTERS = (() => {
  const regimenId = FILTERS.VALIDATION.REGIMES[0].id;
  const year = FILTERS.VALIDATION.YEARS[0];
  return {
    regimenId,
    year,
    damPrefix: `235-${year}-${regimenId}-`,
    damSuffix: "",
    damExtensions: ["01", "1", "00"],
    dni: "",
    volantesForRequest: [],
  };
})();

export const BillingSearchBarAdmin = (props) => {
  const {
    searchHandlers,
    searchError,
    updateSearchError,
    requestStatus,
    dniState,
    volantesForRequestState,
    updateDamSuffixState,
  } = props;
  const { damSearchHandler } = searchHandlers;

  const [regimenId, updateRegimenId] = useState(INITIAL_FILTERS.regimenId);
  const [year, updateYear] = useState(INITIAL_FILTERS.year);
  const [damPrefix, updateDamPrefix] = useState(INITIAL_FILTERS.damPrefix);
  const [damSuffix, updateDamSuffix] = updateDamSuffixState;
  const [damExtensions, updateDamExtensions] = useState(
    INITIAL_FILTERS.damExtensions
  );
  const [dni, updateDni] = dniState;
  const [volantesForRequest, updateVolantesForRequest] =
    volantesForRequestState;
  const multiTagRef: any = useRef();

  const onResetClick = () => {
    if (multiTagRef.current) {
      multiTagRef.current.clear();
    }
    updateRegimenId(INITIAL_FILTERS.regimenId);
    updateYear(INITIAL_FILTERS.year);
    updateDamPrefix(INITIAL_FILTERS.damPrefix);
    updateDamSuffix(INITIAL_FILTERS.damSuffix);
    updateDamExtensions(INITIAL_FILTERS.damExtensions);
    updateDni(INITIAL_FILTERS.dni);
    updateVolantesForRequest(INITIAL_FILTERS.volantesForRequest);
  };
  const toastRef: any = useRef();
  const onButtonClick = () => {
    if (volantesForRequest.length === 0) {
      toastRef.current.show({
        severity: "error",
        detail: "Se debe de ingresar por lo menos un volante.",
      });
      return;
    }
    if (dni.length !== 8) {
      toastRef.current.show({
        severity: "error",
        detail: "Se debe de ingresar un DNI con 8 dígitos.",
      });
      return;
    }
    if (damSuffix.length !== 6) {
      toastRef.current.show({
        severity: "error",
        detail: "Se debe de ingresar un número de dam válido.",
      });
      return;
    }
    const damExtendValid =
      damExtensions[0].length !== 2 ||
      damExtensions[1].length !== 1 ||
      damExtensions[2].length !== 2;

    if (damExtendValid) {
      toastRef.current.show({
        severity: "error",
        detail: "Se debe de ingresar una extensión de dam válido.",
      });
      return;
    }

    if (requestStatus === REQUEST_STATES.REQUEST_IN_PROGRESS) return;
    updateSearchError(false);
    let damValue = damPrefix + damSuffix;

    damExtensions.forEach((damExtension) => {
      damValue += "-" + damExtension;
    });

    const dam = `235${year
      .toString()
      .slice(2)}${regimenId}${damSuffix}${damExtensions.join("")}`;
    const params = { dam, dni: dni.trim(), date: new Date() };
    damSearchHandler(damValue, volantesForRequest, params);
  };
  const damSuffixOnChange = (e) => {
    const text = e.target.value;
    const suffix = text.slice(0, 6);
    let box1 = "",
      box2 = "",
      box3 = "";
    if (text.length > 6) {
      box1 = text.slice(6, 8);
    } else box1 = damExtensions[0];
    if (text.length > 8) {
      box2 = text.slice(8, 9);
    } else box2 = damExtensions[1];
    if (text.length > 9) {
      box3 = text.slice(9, 11);
    } else box3 = damExtensions[2];

    updateDamSuffix(suffix);
    updateDamExtensions([box1, box2, box3]);
  };
  function updateRegimen(ev) {
    updateRegimenId(ev.target.value);
    updateDamPrefix(`235-${year}-${ev.target.value}-`);
  }

  function onYearChange(ev) {
    updateYear(ev.target.value);
    updateDamPrefix(`235-${ev.target.value}-${regimenId}-`);
  }

  return (
    <SearchBar>
      <Toast ref={toastRef}></Toast>
      <div className="year--container">
        <h3>Año</h3>
        <Select
          className="clickable-element"
          onChange={onYearChange}
          onBlur={onYearChange}
          height="4.5rem"
          arrowPosition="1.6rem"
          value={year}
        >
          {FILTERS.VALIDATION.YEARS.map((year) => (
            <option key={year} value={year}>
              {year}
            </option>
          ))}
        </Select>
      </div>
      <div className="regimen--container">
        <h3>Régimen</h3>
        <Select
          className="clickable-element"
          name="regimen"
          onChange={updateRegimen}
          onBlur={updateRegimen}
          height="4.5rem"
          arrowPosition="1.6rem"
          value={regimenId}
        >
          {FILTERS.VALIDATION.REGIMES.map((regimen) => (
            <option key={regimen.id} value={regimen.id}>
              {`${regimen.id}: ${regimen.name}`}
            </option>
          ))}
        </Select>
      </div>
      <div className="dni--container">
        <h3>DNI:</h3>
        <Input
          width="15rem"
          value={dni}
          onChange={(ev) => updateDni(ev.target.value)}
          placeholder="07502486"
          onKeyPress={onlyDigits}
          maxLength={DOCUMENT_DNI_MAX_LENGTH}
        />
      </div>

      <div className="dam--container">
        <h3>Número de DAM:</h3>
        <DamInput>
          <div className="dam-prefix">{damPrefix}</div>
          <DamSuffix
            type="text"
            className="DAMSuffix"
            placeholder={`123456`}
            value={damSuffix}
            onChange={damSuffixOnChange}
            hasError={searchError}
            onKeyPress={onlyDigitsNumbers}
            maxLength={DAM_MAX_LENGTH}
          />
          <div className="dash-separator">-</div>
          <DamExtension
            type="text"
            hasError={searchError}
            value={damExtensions[0]}
            onChange={(e) => {
              const newDamExtensions = [...damExtensions];
              const newDamExtension = e.target.value.slice(0, 2);
              newDamExtensions[0] = newDamExtension;
              updateDamExtensions(newDamExtensions);
            }}
            onKeyPress={onlyDigitsNumbers}
            maxLength={DAM_EXTENSION_TWO_MAX_LENGTH}
          />
          <div className="dash-separator">-</div>
          <DamExtension
            type="text"
            hasError={searchError}
            value={damExtensions[1]}
            onChange={(e) => {
              const newDamExtensions = [...damExtensions];
              const newDamExtension = e.target.value.slice(0, 1);
              newDamExtensions[1] = newDamExtension;
              updateDamExtensions(newDamExtensions);
            }}
            onKeyPress={onlyDigitsNumbers}
            maxLength={DAM_EXTENSION_ONE_MAX_LENGTH}
          />
          <div className="dash-separator">-</div>
          <DamExtension
            type="text"
            hasError={searchError}
            value={damExtensions[2]}
            onChange={(e) => {
              const newDamExtensions = [...damExtensions];
              const newDamExtension = e.target.value.slice(0, 2);
              newDamExtensions[2] = newDamExtension;
              updateDamExtensions(newDamExtensions);
            }}
            onKeyPress={onlyDigitsNumbers}
            maxLength={DAM_EXTENSION_TWO_MAX_LENGTH}
          />
        </DamInput>
      </div>
      <div className="volantes--container">
        <h3>Números de Volantes:</h3>
        <MultipleTagInput
          ref={multiTagRef}
          tagList={volantesForRequest}
          onTagListUpdate={updateVolantesForRequest}
          hasError={searchError}
        />
      </div>

      <div className="search-button--container">
        <Authorization actions={["dam.get_dam_estimate_backoffice"]}>
          <ResetButton onClick={onResetClick} />
          <SearchButton
            disabled={requestStatus === REQUEST_STATES.REQUEST_IN_PROGRESS}
            onClick={onButtonClick}
          />
        </Authorization>
      </div>
    </SearchBar>
  );
};
